import React from "react";
import { IconProps } from "./types";

function IconOutgoingMessageSquare({
  className = "stroke-slate-500 fill-slate-500",
  ...props
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8826 4.00253L10.4626 4.00253C9.35106 4.00252 8.4545 4.00251 7.72847 4.06046C6.98094 4.12013 6.32433 4.2462 5.71686 4.5486C4.75193 5.02893 3.96741 5.79538 3.47576 6.73809C3.16623 7.33158 3.03719 7.97306 2.97612 8.70338C2.9168 9.41269 2.91681 10.2886 2.91682 11.3746L2.91682 18.3648L2.91678 18.5195C2.91641 19.6123 2.91616 20.358 3.09155 20.9975C3.56574 22.7265 4.94804 24.077 6.71773 24.5402C7.18767 24.6632 7.71364 24.6978 8.38689 24.7074L8.38688 26.8688C8.38685 27.1904 8.38681 27.4967 8.40976 27.7436C8.43194 27.9821 8.48764 28.3713 8.76032 28.705C9.08508 29.1025 9.57755 29.3337 10.0981 29.3332C10.5352 29.3327 10.881 29.1321 11.0855 29C11.2972 28.8633 11.542 28.6719 11.799 28.471L15.0928 25.8966C15.7913 25.3507 16.0325 25.1683 16.2894 25.0401C16.5362 24.9168 16.799 24.8268 17.0706 24.7723C17.3532 24.7157 17.6582 24.7109 18.5527 24.7109H20.6701C21.7817 24.7109 22.6782 24.711 23.4042 24.653C24.1518 24.5933 24.8084 24.4673 25.4159 24.1649C26.3808 23.6845 27.1653 22.9181 27.657 21.9754C27.9665 21.3819 28.0955 20.7404 28.1566 20.0101C28.2159 19.3008 28.2159 18.4249 28.2159 17.3389V17.0288C28.2159 16.4754 27.7567 16.0268 27.1903 16.0268C26.6238 16.0268 26.1646 16.4754 26.1646 17.0288V17.296C26.1646 18.4349 26.1638 19.2288 26.1121 19.8469C26.0614 20.4533 25.9669 20.8017 25.8293 21.0656C25.5343 21.6312 25.0636 22.0911 24.4846 22.3793C24.2145 22.5137 23.8579 22.6061 23.2372 22.6556C22.6045 22.7061 21.7919 22.7069 20.6262 22.7069H18.5527L18.4538 22.7069C17.6953 22.7067 17.17 22.7066 16.6582 22.8092C16.2056 22.8999 15.7676 23.05 15.3561 23.2554C14.8909 23.4877 14.4808 23.8083 13.8886 24.2714L13.8114 24.3317L10.5493 26.8814L10.4382 26.968L10.4382 26.8292V23.7089C10.4382 23.1555 9.97897 22.7069 9.41253 22.7069C8.07474 22.7069 7.60705 22.6983 7.24864 22.6045C6.18682 22.3265 5.35745 21.5162 5.07294 20.4789C4.9769 20.1287 4.96809 19.6718 4.96809 18.3648V11.4175C4.96809 10.2786 4.96889 9.48466 5.02058 8.86657C5.07129 8.26018 5.16583 7.91179 5.30346 7.64791C5.59845 7.08228 6.06916 6.62241 6.64812 6.33421C6.91823 6.19975 7.27483 6.10739 7.89551 6.05785C8.52817 6.00735 9.34079 6.00657 10.5065 6.00657H14.8826C15.449 6.00657 15.9082 5.55795 15.9082 5.00455C15.9082 4.45115 15.449 4.00253 14.8826 4.00253Z"
        fill="inherit"
        stroke="none"
      />
      <path
        d="M21.5833 10.6667L28.2499 4"
        stroke="inherit"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.25 10V4H22.25"
        stroke="inherit"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IconOutgoingMessageSquare;
